import * as React from "react";
import { Button, Modal } from "semantic-ui-react";

import { IsLoadingButton } from "@teamprevent/common/IsLoadingButton";

import { UPDATE_ADDITIONAL_MANAGERS } from "../../actiontypes";
import { isCaseManager } from "../../../../auth/model";

import { ManageAssignedUsers, ManageAssignedUsersProps, DispatchProps } from "./ManageAssignedUsers";

export class ManageAssignedUsersModal extends React.Component<ManageAssignedUsersProps & DispatchProps> {
    constructor(props: ManageAssignedUsersProps & DispatchProps) {
        super(props);
        this.onClose = this.onClose.bind(this);

        if (!isCaseManager(this.props.currentUser)) {
            this.props.close();
        }
    }

    private manageAssignedUsersForm: ManageAssignedUsers;

    public render() {
        const model = {
            ...this.props.model,
        };
        return (
            <>
                {isCaseManager(this.props.currentUser) ?
                    <Modal size="small" open={this.props.open} onClose={this.props.close} closeOnDimmerClick={false}>
                        <Modal.Header>Manage Assigned Users</Modal.Header>
                        <Modal.Content>
                            <ManageAssignedUsers
                                open={this.props.open}
                                save={this.props.save}
                                model={model}
                                ref={instance => this.manageAssignedUsersForm = instance}
                                currentUser={this.props.currentUser}
                                close={this.props.close}
                                getHrRepresentatives={this.props.getHrRepresentatives}
                                getLineManagers={this.props.getLineManagers}
                            />
                        </Modal.Content>
                        <Modal.Actions>
                            <Button onClick={this.onClose}>Cancel</Button>
                            <IsLoadingButton requestNames={UPDATE_ADDITIONAL_MANAGERS} content="Save" onClick={this.onSubmit} />
                        </Modal.Actions>
                    </Modal>
                    : null
                }
            </>
        );
    }

    private onClose() {
        this.props.close();
    }

    private onSubmit = () => this.manageAssignedUsersForm.submit();
}
